package Structs

import Utils.getJsonWithConfig
import kotlinx.serialization.KSerializer
import kotlinx.serialization.descriptors.PrimitiveKind
import kotlinx.serialization.descriptors.PrimitiveSerialDescriptor
import kotlinx.serialization.descriptors.SerialDescriptor
import kotlinx.serialization.encoding.Decoder
import kotlinx.serialization.encoding.Encoder
import kotlinx.serialization.json.JsonArray
import kotlinx.serialization.json.JsonDecoder
import kotlinx.serialization.json.JsonElement
import kotlinx.serialization.json.JsonNull
import kotlinx.serialization.json.JsonObject
import kotlinx.serialization.json.JsonPrimitive

/** Accepts blocked_dates as JSON string or parsed array/object (legacy API responses). */
object BlockedDatesJsonStringSerializer : KSerializer<String?> {
    override val descriptor: SerialDescriptor =
        PrimitiveSerialDescriptor("BlockedDatesJsonString", PrimitiveKind.STRING)

    override fun serialize(encoder: Encoder, value: String?) {
        if (value == null) encoder.encodeNull()
        else encoder.encodeString(value)
    }

    override fun deserialize(decoder: Decoder): String? {
        val jsonDecoder = decoder as? JsonDecoder
        if (jsonDecoder != null) {
            return when (val element = jsonDecoder.decodeJsonElement()) {
                is JsonNull -> null
                is JsonPrimitive -> {
                    val content = element.content
                    when {
                        content.isEmpty() || content == "null" || content == "None" -> null
                        else -> content
                    }
                }
                is JsonArray, is JsonObject ->
                    getJsonWithConfig().encodeToString(JsonElement.serializer(), element)
                else -> null
            }
        }
        return try {
            decoder.decodeString()
        } catch (_: Exception) {
            null
        }
    }
}
